// extracted by mini-css-extract-plugin
export var benefits = "components-banners-__RegisterForCharlieAccount-module___benefits";
export var containerWidth = "components-banners-__RegisterForCharlieAccount-module___containerWidth";
export var image = "components-banners-__RegisterForCharlieAccount-module___image";
export var wrapper = "components-banners-__RegisterForCharlieAccount-module___wrapper";